import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4a6cd20b&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=4a6cd20b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.10.1_cache-loader@4.1.0_webpack@4.46.0__css-loader@3.6.0_webpack@4.46.0__lodash_24cgfdmwo65apd3bkbnxqthoqi/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6cd20b",
  null
  
)

export default component.exports